import React, { Fragment } from "react";
import { connect } from "react-redux";
import ROUTES from "config/routes";
import TitleIcon from "components/TitleIcon";
import Button from "components/Button";
import SocialLinks from "components/SocialLinks";
import FooterMenu from "./FooterMenu";

function Footer(props) {
  const { common } = props;
  const bannerText = common?.footer?.bannerText;
  const bannerImages = common?.footer?.bannerImages;

  const menuItems = [
    { title: "Privacy", url: ROUTES.privacy },
    { title: "Terms and Conditions", url: ROUTES.terms },
    { title: "Contact Us", url: ROUTES.contactUs },
    { title: "Site map", url: ROUTES.sitemap, type: "new" },
  ];

  return (
    <Fragment>
      <footer className="footer">
        <div className="footer-body">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-12">
                <TitleIcon align="center" color="white" withTm={true}>
                  <h2 className="section-title section-title--white">
                    {bannerText}
                  </h2>
                </TitleIcon>
              </div>
              <div className="col-md-3 col-12 justify-content-end d-flex">
                <Button bgColor="white" to={ROUTES.advertisingSponsorship}>
                  Learn more
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div
                  className="banner-images"
                  dangerouslySetInnerHTML={{ __html: bannerImages }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="bottom">
            <div className="row">
              <div className="col-12 col-lg-5">
                <FooterMenu menuItems={menuItems} />
              </div>
              <div className="col-12 col-lg-2">
                <div className="copyright text-center">
                  © 2025 WeCare4
                  <br />
                  All rights reserved.
                </div>
              </div>
              <div className="col-12 col-lg-5">
                <SocialLinks color="white" socials={props.socials} />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
}

export default connect((state) => ({
  common: state.pages.common,
}))(Footer);
